import React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { uiCloseBackdrop } from 'reducers/uiReducer/uiActions';

export const CustomBackDrop = () => {
    const {backdrop} = useSelector(state => state.ui);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(uiCloseBackdrop());
    }
  return (
    <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdrop}
        onClick={handleClose}
    >
        <CircularProgress color="inherit" />
    </Backdrop>
  )
}
